<template>
    <div class="row justify-content-center mt-3" v-if="!loading">
        <div class="col-auto scroll-table" v-if="monederos && monederos.length > 0">
            <table class="table table-responsive">
                <thead>
                    <tr>
                        <th class="text-center mansana" style="font-size: 12.5px; padding: 12px;" scope="col">Descripción</th>
                        <th class="text-center mansana" style="font-size: 12.5px; padding: 12px;" scope="col">Unidades</th>
                    </tr>
                </thead>
                <tbody>
                    <template  v-for="monedero in monederos">
                        <tr :key="monedero.id">
                            <td class="text-center mansana" style="font-size: 12.5px; padding: 12px;">{{ monedero.descripcion }}</td>
                            <td class="text-center mansana" style="font-size: 12.5px; padding: 12px;">{{ monedero.importe }} unidades</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <hr class="mb-2">
            <div class="d-flex justify-content-end align-items-center">
                <h4 class="mr-5">Total</h4>
                <h5 class="mr-3 pr-1 pt-1">{{ total }} unidades</h5>
            </div>
        </div>
        <h4 class="text-center" v-else>Si ha liberado algún asiento y el club así lo dispone, se le abonará al monedero el dinero definido por el club cuando alguna de sus butacas liberadas sea vendida.</h4>
    </div>
    <div style="padding: 50px;" v-else>
        <LoaderComponent></LoaderComponent>
    </div>
</template>

<script>
export default {
    data() {
        return {
            monederos: null,
            loading: false
        }
    },
    created() {
        this.getMonedero();
    },
    methods: {
        getMonedero() {
            this.loading = true;

            const data = {
                filters: {}, 
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.monederos'), data).then(res => {
                this.monederos = res.data.monederos;
                this.loading = false;
            });
        }
    },
    computed: {
        total() {
            var total = 0;
            for(var i in this.monederos) {
                total = total + parseFloat(this.monederos[i].importe);
            }

            return total;
        },
    }
}
</script>